if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer) return;

        this.slides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        this.updateNavButtons(0);
        
        // Find next/prev
        const nextBtn = this.querySelector(".slider-button--next");
        const prevBtn = this.querySelector(".slider-button--prev");

        // 🔹 REMOVE all existing event listeners from Shopify
        if (nextBtn) {
          const newNext = nextBtn.cloneNode(true);
          nextBtn.parentNode.replaceChild(newNext, nextBtn);
          newNext.addEventListener("click", () => this.changeSlide("next"));
        }

        if (prevBtn) {
          const newPrev = prevBtn.cloneNode(true);
          prevBtn.parentNode.replaceChild(newPrev, prevBtn);
          newPrev.addEventListener("click", () => this.changeSlide("prev"));
        }

        // Keep thumbnails logic
        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500)
          );

          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });

          if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
            this.removeListSemantic();
          }
        }
      }

      changeSlide(direction) {
        const activeSlide = this.elements.viewer.querySelector(".is-active");
        if (!activeSlide) return;

        let currentIndex = this.slides.indexOf(activeSlide);
        let newIndex =
          direction === "next"
            ? (currentIndex + 1) % this.slides.length
            : (currentIndex - 1 + this.slides.length) % this.slides.length;

        let nextMediaId = this.slides[newIndex].dataset.mediaId;
        this.setActiveMedia(nextMediaId, false);
        this.updateNavButtons(newIndex);
      }

      updateNavButtons(index) {
        const nextBtn = this.querySelector(".slider-button--next");
        const prevBtn = this.querySelector(".slider-button--prev");
        // Check if looping is enabled on slider-component 
        const isLooping = this.elements.viewer?.dataset.loop === "true";
        if (isLooping) {
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
          return;
        }
        // Default behavior (non-looping) 
        if (prevBtn) {
          prevBtn.disabled = index === 0;
        } if (nextBtn) {
          nextBtn.disabled = index === this.slides.length - 1;
        }
      }

      // The rest of your original methods stay the same...
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
         this.slides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('.is-active').forEach(el => {
          el.classList.remove('is-active');
        });
        
        activeMedia.classList.add('is-active');


        const img = activeMedia.querySelector("img");
        if (img && img.loading === "lazy") {
          img.loading = "eager";
          img.src = img.src;
        }

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumb.parentElement.firstChild !== activeThumb &&
              activeThumb.parentElement.prepend(activeThumb);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;
          const top = rect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumb);
        this.announceLiveRegion(activeMedia, activeThumb.dataset.mediaPosition);

        const newIndex = this.slides.indexOf(activeMedia);
        this.updateNavButtons(newIndex);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((btn) => btn.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}